import { render, staticRenderFns } from "./Noticias.vue?vue&type=template&id=35f46cd0&scoped=true"
import script from "./Noticias.vue?vue&type=script&lang=js"
export * from "./Noticias.vue?vue&type=script&lang=js"
import style0 from "./Noticias.vue?vue&type=style&index=0&id=35f46cd0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f46cd0",
  null
  
)

export default component.exports